// extracted by mini-css-extract-plugin
export default {"section":"DashboardSection_section__rJImP","title":"DashboardSection_title__4mLEA"};